module.exports = __webpack_public_path__ + "img/search-status.cc8eb4e6.svg";